import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";
import getSymbolFromCurrency from "currency-symbol-map";
import swal from 'sweetalert'; // Import SweetAlert

function Products(props) {
  const [data, setData] = useState([]);
  const { token } = isAutheticated();

  const [currentPage, setCurrentPage] = useState(1);
  const [success, setSuccess] = useState(false);


  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState(data);
  const [loading, setLoading] = useState(false);

  const [currency, setCurrency] = useState();

  useEffect(() => {
    async function fetchData() {
      await axios
        .get(`${API}/api/user`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setCurrency(res.data.data.settings.currency);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    fetchData();
  }, [token]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true); // Start loading
      try {
        const res = await axios.get(`${API}/api/product`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(res.data.data);
      } catch (error) {
        console.error(error); // Handle errors
      } finally {
        setLoading(false); // Stop loading
      }
    };
    getData();
  }, [success, token]);
  console.log(data);

  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);

  const handleDelete = async (id) => {

    const status = await swal({
      title: "Are you sure?",
      text: "Do you want to delete this Product?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    // If the user confirms, proceed with deletion
    if (!status) {
      return;
    }
    try {
      let res = await axios.delete(`${API}/api/product/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res) {

        setSuccess(!success); // Trigger state update or re-fetch
        swal("Deleted!", "The Product has been deleted successfully.", "success");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      swal("Error", "There was an issue deleting the Product.", "error");
    }

  }




  const ChangeSatusHandler = async (id) => {
    let res = await axios.get(
      `${API}/api/product/change_product_status/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res) {
      setSuccess(!success);
      // window.location.reload();
    }
  };

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          {/* <!-- start page title --> */}
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>OTT Shop - Products</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>OTT Shop - Products</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- end page title --> */}

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_length'>
                        <label className='w-100'>
                          Show{" "}
                          <select
                            name=''
                            className='select-w custom-select custom-select-sm form-control form-control-sm'
                            value={itemPerPage}
                            onChange={(e) => setItemPerPage(e.target.value)}>
                            <option value='10'>10</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dropdown d-block'>
                        <Link to='/comproducts/add'>
                          <button
                            type='button'
                            className='btn btn-primary add-btn waves-effect waves-light float-right'>
                            <i className='fa fa-plus' aria-hidden='true'></i>{" "}
                            Add New Product
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light'>
                        <tr>
                          <th>Thumbnail</th>
                          <th>Name</th>
                          {/* <th>Stock</th> */}
                          {/* <th>Sale Price</th> */}
                          {/* <th>Tax</th> */}
                          <th>Total Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData.length > 0 ? (
                          showData.map(
                            (item) =>
                              item.title && (
                                <tr key={item._id}>
                                  <td>
                                    <img src={item.image} width="75" height="100" alt="" />
                                  </td>
                                  <td>{item.title}</td>
                                  {item.variants ? (
                                    <td colSpan="4" align="center">
                                      Variants exist for this product.
                                    </td>
                                  ) : (
                                    <>
                                      {/* <td>{item.quantity}</td> */}
                                      {/* <td> */}
                                      {/* {getSymbolFromCurrency(currency)} */}
                                      {/* {item.sale_price} */}
                                      {/* </td> */}
                                      {/* <td>{item.tax?.tax_name}({item.tax?.tax_percentage}%)</td> */}
                                      <td>
                                        {/* {getSymbolFromCurrency(currency)} */}
                                        ${item?.total_price}
                                      </td>
                                    </>
                                  )}
                                  <td>
                                    {item.status ? (
                                      <span className="badge badge-pill badge-success font-size-12">
                                        Live
                                      </span>
                                    ) : (
                                      <span className="badge badge-pill badge-danger font-size-12">
                                        Suspended
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <button
                                      onClick={() => ChangeSatusHandler(item._id)}
                                      type="button"
                                      className="btn btn-success btn-sm waves-effect waves-light btn-table"
                                    >
                                      {item.status ? "Suspend" : "Active"}
                                    </button>
                                    <Link to={`/comproducts/edit/${item._id}`}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm waves-effect waves-light btn-table ml-2"
                                      >
                                        Edit
                                      </button>
                                    </Link>
                                    <Link to={`/comproducts/view/${item._id}`}>
                                      <button
                                        type="button"
                                        className="btn btn-dark btn-sm waves-effect waves-light btn-table ml-2"
                                      >
                                        View
                                      </button>
                                    </Link>
                                    <button
                                      type="button"
                                      onClick={() => handleDelete(item._id)}
                                      className="btn btn-danger btn-sm waves-effect waves-light btn-table ml-2"
                                      id="sa-params"
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              )
                          )
                        ) : (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                No Products Found. Please add products to display here.
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>

                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                        {data.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* <!-- end table-responsive --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      {/* <footer className="footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <script>document.write(new Date().getFullYear())</script> © SoComOTT.
                        </div>

                    </div>
                </div>
            </footer> */}
      <Footer />
    </div>
  );
}

export default Products;
